// src/apiService.js
import axios from 'axios';
import { environment } from 'environment/environment';

const api = axios.create({
  baseURL: environment.apiHostStartPoint,
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${sessionStorage.getItem('token')}`
  }
});

api.interceptors.request.use(
 async (config) => {
  const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Reusable POST function
export const post = async (url, data) => {
  try {
    const response = await api.post(url, data);
    if (response.status == 201) {
      return response.data;
    } else {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error('Error in POST request:', error);
    // toast.error(error)
    throw error;
  }
};

// Reusable GET function
export const get = async (url, params) => {
  try {
    const response = await api.get(url, { ...params });
    if (response.status == 200) {
      return response.data;
    } else {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error('Error in GET request:', error);
    throw error;
  }
};

// Reusable PUT function
export const put = async (url, data) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in PUT request:', error);
    throw error;
  }
};

// Reusable DELETE function
export const del = async (url, params) => {
  try {
    const response = await api.delete(url, { params });
    return response.data;
  } catch (error) {
    console.error('Error in DELETE request:', error);
    throw error;
  }
};

// Reusable PATCH function
export const patch = async (url, data) => {
  try {
    const response = await api.patch(url, data);
    return response.data;
  } catch (error) {
    console.error('Error in PATCH request:', error);
    throw error;
  }
};
